<template>
  <!-- 政区暂时取消   用责任区的页面 -->
  <div class="dutyAreaPage">
    <div class="titInfo">
      <p>{{ baseData.regionName }}信息</p>
    </div>
    <div class="forestMap">
      <!-- 地图页 -->
      <map-locator :param="mapData" mode="h5"></map-locator>
    </div>
    <div :class="['forestTab']">
      <van-tabs v-model="activeName">
        <van-tab title="基本信息" name="dutyAreatMsg" class="baseMsg">
          <duty-area-msg :dataInfo="paramData"></duty-area-msg>
          <!-- <van-cell-group class="forestInput">
            <van-field
              :value="baseData.gridName ? baseData.gridName : '无'"
              readonly
              label="责任区名称："
            />
            <van-field
              :value="getGridLevelName(baseData.gridLevel)"
              readonly
              label="责任区级别："
            />
            <van-field
              :value="baseData.area ? baseData.area : '无'"
              readonly
              label="面积(公顷)："
            />
            <van-field
              :value="baseData.regionName ? baseData.regionName : '无'"
              readonly
              label="所属政区："
            />
          </van-cell-group> -->
        </van-tab>
        <!-- <van-tab title="责任区人员" name="dutyMsg" class="baseMsg">
         <div class="TabsList propleList">
            <div
              v-for="(item, index) in zrqPeopleList"
              :key="index"
              class="itemList clearfix"
            >
              <p>
                {{ item.userName }}
                <van-tag type="warning">{{ item.position }}</van-tag>
              </p>
              <p class="orgName">{{ item.orgName }}</p>
              <span class="xunLType">{{ item.postName }}</span>
              <p class="protectForestTime">{{ item.phone }}</p>
            </div>
            <div class="emptypage" v-if="zrqPeopleList.length < 1">
              <van-image :src="baseUrl + 'empty.png'" />
            </div>
          </div> 
        </van-tab> -->
        <!-- 替换上面的责任区人员信息 -->
        <van-tab title="资源信息" name="dutyMsg" class="baseMsg">
          <pub-resource :dataInfo="paramData"></pub-resource>
        </van-tab>
        <van-tab
          title="电子公示牌"
          name="dutyAreaPublicity"
          class="dutyAreaPublicity baseMsg"
        >
          <duty-area-publicity :dataInfo="paramData"></duty-area-publicity>
        </van-tab>
        <van-tab title="群众建议" name="massesAdvise" class="baseMsg">
          <area-advise :dataInfo="paramData"></area-advise>
        </van-tab>
        <!-- <van-tab
          v-for="(item, index) in msgList"
          :key="item.id"
          :title="item.postName"
          :name="'dutyArea' + index"
          class="baseMsg"
        >
          <duty-area-policy :dataInfo="item"></duty-area-policy>
        </van-tab> -->
        <!-- <van-tab title="巡林记录" name="dutyAreaPublicity" class="baseMsg">
          <div class="TabsList propleList">
            <van-list
              v-model="recordLoading"
              :finished="finished"
              finished-text="没有更多了"
              @load="loadBaselist"
            >
              <div
                v-for="(item, index) in xunlinList"
                :key="index"
                class="itemList clear"
              >
                <div v-if="item.type == 'qd'">
                  <p>
                    {{ item.userName }}
                  </p>
                  <p class="orgName">签到时间:{{ item.signTime }}</p>
                  <p class="orgName">签到位置:{{ item.signLocation }}</p>
                  <span class="xunLType">{{
                    item.type == "qd"
                      ? "签到"
                      : item.type == "hld"
                      ? "护林单"
                      : item.type == "xl"
                      ? "巡林"
                      : ""
                  }}</span>
                </div>
                <div v-if="item.type == 'xl'">
                  <p>
                    {{ item.userName }}
                  </p>
                  <p class="orgName">开始时间:{{ item.startTime }}</p>
                  <p class="orgName">结束时间:{{ item.endTime }}</p>
                  <p class="orgName">巡林里程:{{ item.distance }}(公里)</p>
                  <p class="orgName">巡林时长:{{ item.portalTime }}</p>
                  <span class="xunLType">{{
                    item.type == "qd"
                      ? "签到"
                      : item.type == "hld"
                      ? "护林单"
                      : item.type == "xl"
                      ? "巡林"
                      : ""
                  }}</span>
                </div>
                <div v-if="item.type == 'hld'">
                  <p>
                    {{ item.userName }}
                  </p>
                  <p class="orgName">开始时间:{{ item.startTime }}</p>
                  <p class="orgName">结束时间:{{ item.endTime }}</p>
                  <p class="orgName">参与人员:{{ item.userNames }}</p>
                  <span class="xunLType">{{
                    item.type == "qd"
                      ? "签到"
                      : item.type == "hld"
                      ? "护林单"
                      : item.type == "xl"
                      ? "巡林"
                      : ""
                  }}</span>
                </div>
              </div>
            </van-list>
            <div class="emptypage" v-if="zrqPeopleList.length < 1">
              <van-image :src="baseUrl + 'empty.png'" />
            </div>
          </div>
        </van-tab> -->
      </van-tabs>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
const mapLocator = () => import("@/views/pub/components/pubMapLocator");
const refreshPage = () => import("@/components/common/refreshPage");
const dutyAreaMsg = () => import("@/views/pub/components/zrqAreaMsg");
const dutyAreaPolicy = () => import("@/views/pub/components/areaPolicy");
const pubResource = () => import("@/views/pub/components/pubResource");
const areaAdvise = () => import("@/views/pub/components/massesAdvise");

const dutyAreaPublicity = () =>
  import("@/views/pub/components/commonPublicity");
// import { getToken } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "pubZqInfo",
  components: {
    dutyAreaMsg,
    pubResource,
    dutyAreaPolicy,
    mapLocator,
    areaAdvise,
    dutyAreaPublicity
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      activeName: "dutyAreatMsg", //默认选中第一项
      objid: "", //objId
      gridLevel: "", //责任区等级
      gridType: "", //责任区类型
      gridZqcode: "",
      mapData: {
        type: "",
        objid: "",
      },

      baseData: {
        gridName: "",
        gridLevel: "",
        area: "",
        zqName: "",
      },
      paramData: {
        objid: "",
        level: "",
        zqCode: "",
        type: "",
        areaType: "zq",
      },
      msgList: [], //根据责任区|政区获取文本信息list

      zrqPeopleList: [],
      sourceList: [],
      xunlinList: [],
      recordLoading: true,
      finished: false,
      pageNum: 0,
      pageSize: 30,
      sourceTotal: 0,
      clientType: "", //手机类型
    };
  },

  mounted() {
    document.title = "责任区信息";

    this.clientType = getDeviceType();
    this.objid = this.$route.query.commonId;
    this.gridLevel = this.$route.query.zqLevel;
    this.gridZqcode = this.$route.query.zqCode;
    this.mapData.type = this.getGridType(this.gridLevel);
    this.mapData.objid = this.$route.query.commonId;
    this.getGridArchives("zq", this.gridLevel, this.objid, this.gridZqcode);
    this.getGridAreaDetails(this.gridLevel, this.objid, "zq", this.gridZqcode);
    this.getGridMergeForestList();
    this.paramData.objid = this.objid;
    this.paramData.level = this.gridLevel;
    this.paramData.zqCode = this.gridZqcode;
    this.paramData.type = this.getGridType(this.gridLevel);
  },
  methods: {
    getLevel(type) {
      //获取责任区等级
      let grade = "";
      if (type == "geo_grid_sheng" || type == "geo_sheng") {
        grade = "1";
      } else if (type == "geo_grid_shi" || type == "geo_shi") {
        grade = "2";
      } else if (type == "geo_grid_xian" || type == "geo_xian") {
        grade = "3";
      } else if (type == "geo_grid_xiang" || type == "geo_xiang") {
        grade = "4";
      } else {
        grade = "5";
      }
      return grade;
    },
    getGridType(grid) {
      //这里仅仅获取政区信息
      let type = "";
      if (grid == "1") {
        type = "geo_sheng";
      } else if (grid == "2") {
        type = "geo_shi";
      } else if (grid == "3") {
        type = "geo_xian";
      } else if (grid == "4") {
        type = "geo_xiang";
      } else {
        type = "geo_cun";
      }
      return type;
    },
    getGridLevelName(level) {
      let typeName = "";
      if (level == "1") {
        typeName = "省级";
      } else if (level == "2") {
        typeName = "市级";
      } else if (level == "3") {
        typeName = "区/县级";
      } else if (level == "4") {
        typeName = "乡/镇级";
      } else if (level == "5") {
        typeName = "村级";
      } else {
        typeName = "无";
      }
      return typeName;
    },
    getGridArchives(type, level, objid, zqCode) {
      let _this = this;
      _this.$api.pubZrq
        .getGridArchives({
          type: type,
          level: level,
          objid: objid,
          zqCode: zqCode,
        })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.msgList = res.data;
          }
        });
    },
    getGridAreaDetails(level, objid, type, zqCode) {
      let _this = this;
      _this.$api.pubZrq
        .gridAreaDetails({
          type: type,
          level: level,
          objid: objid,
          zqCode: zqCode,
        })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.baseData = res.data;

            _this.$set(
              _this.baseData,
              "gridLeve",
              _this.baseData.gridLeve == "1"
                ? "省级"
                : _this.baseData.gridLeve == "2"
                ? "市级"
                : _this.baseData.gridLeve == "3"
                ? "区/县级"
                : _this.baseData.gridLeve == "4"
                ? "乡/镇级"
                : _this.baseData.gridLeve == "5"
                ? "村级"
                : "无"
            );
            // _this.baseData.gridLeve =
            // _this.baseData.gridLeve == "1"
            //     ? "省级"
            //     :  _this.baseData.gridLeve == "2"
            //     ? "市级"
            //     :  _this.baseData.gridLeve == "3"
            //     ? "区/县级"
            //     :  _this.baseData.gridLeve == "4"
            //     ? "乡/镇级"
            //     :  _this.baseData.gridLeve == "5"
            //     ? "村级"
            //     : "";
            console.log(_this.baseData.gridLeve, " _this.baseData.gridLeve");
            if (res.data.userAreaList[0]) {
              _this.zrqPeopleList = res.data.userAreaList;
            }
          }
        });
    },
    getGridMergeForestList() {
      let _this = this;
      if (
        _this.pageNum != 0 &&
        _this.pageNum * _this.pageSize >= parseInt(_this.sourceTotal)
      ) {
        return;
      }
      _this.pageNum += 1;
      _this.$api.pubZrq
        .gridMergeForestList(_this.pageNum, _this.pageSize, {
          zqType: "zq",
          level: _this.gridLevel,
          objid: _this.objid,
          regionCode: _this.gridZqcode,
        })
        .then((res) => {
          if (res.code == "1" && res.data.list[0]) {
            _this.sourceTotal = parseInt(res.data.total);
            _this.sourceList = res.data.list;
            _this.viewLists();
            this.recordLoading = false;
            if (_this.pageNum * _this.pageSize >= _this.sourceTotal) {
              _this.finished = true;
            }
          }
        })
        .catch((err) => {
          this.finished = true;
          console.log(err);
        });
    },
    viewLists() {
      let _this = this;
      _this.xunlinList = _this.xunlinList.concat(this.sourceList);
    },
    loadBaselist() {
      this.getGridMergeForestList();
    },
  },
};
</script>
<style lang="less">
.dutyAreaPage {
  width: 100%;
  height: 100%;
  .titInfo {
    width: 100%;
    padding: 0 16px;
    p {
      text-align: center;
      line-height: 45px;
      font-size: 15px;
      color: #666;
    }
  }
  .forestMap {
    width: 100%;
    height: 40%;
    > div {
      height: 100%;
    }
  }

  .forestTab {
    width: 100%;
    height: calc(60% - 45px);
    .van-tabs {
      height: 100%;
      overflow: hidden;

      .van-tabs__line {
        background-color: #4bc08a;
      }

      .van-tab--active {
        .van-tab__text {
          color: #4bc08a;
        }
      }
      .van-tabs__wrap {
        height: 45px;
      }

      .van-tabs__content {
        width: 100%;
        height: calc(100% - 45px);

        .baseMsg.van-tab__pane {
          width: 100%;
          height: 100%;
          background-color: #f6f6f6;
        }
        .propleList {
          height: calc(100% - 5px);
          overflow-y: scroll;
        }
        .TabsList {
          width: 100%;
          padding: 0 16px;

          padding-bottom: 30px;
          .itemList {
            background: #fff;
            box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.11);
            border-radius: 6px;
            padding: 14px 12px;
            margin: 12px auto;
            position: relative;
            p {
              margin: 6px 0;
              font-size: 14px;
              color: #000;
              line-height: 20px;
              opacity: 0.4;
            }
            p:first-child {
              font-size: 16px;

              color: #333;
              line-height: 24px;
              opacity: 1;
              .van-tag.van-tag--warning {
                background-color: #fff6e6;
                color: #ffa70a;
                font-size: 10px;
                padding: 2px 2px;
              }
            }
            p.protectForestTime {
              font-size: 12px;
            }
            .xunLType {
              position: absolute;
              right: 24px;
              top: 32px;
              font-size: 16px;
              font-weight: 400;
              color: #5d5c5c;
              line-height: 22px;
            }
          }
        }
      }
    }
  }
  .emptypage {
    width: 116px;
    height: 125px;
    position: absolute;
    top: 25%;
    left: 50%;
    margin-left: -58px;
  }
}
</style>